export default [
  {
    path: '/stories/authors',
    name: 'stories-authors-index',
    role: ['admin', 'developer'],
    meta: {
      loadState: true,
      requiresAuth: true,
      isAuthView: false,
      parentGroup: 'stories',
    },
    component: () => import('@/views/stories/authors/Index'),
  },
  {
    path: '/stories/authors/create',
    name: 'stories-author-create',
    role: ['admin', 'developer'],
    meta: {
      loadState: true,
      requiresAuth: true,
      isAuthView: false,
      parentGroup: 'stories',
    },
    component: () => import('@/views/stories/authors/Create'),
  },
  {
    path: '/stories/authors/edit/:id',
    name: 'stories-author-edit',
    role: ['admin', 'developer'],
    meta: {
      loadState: true,
      requiresAuth: true,
      isAuthView: false,
      parentGroup: 'stories',
    },
    component: () => import('@/views/stories/authors/Edit'),
  },
];
